import { render, staticRenderFns } from "./PopoverPortal.vue?vue&type=template&id=66b2fde2&scoped=true&"
import script from "./PopoverPortal.vue?vue&type=script&lang=js&"
export * from "./PopoverPortal.vue?vue&type=script&lang=js&"
import style0 from "./PopoverPortal.vue?vue&type=style&index=0&id=66b2fde2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2fde2",
  null
  
)

export default component.exports